import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Section84_1FormComponent,
} from '../components/calculations/section-84_1/form/section-84_1-form/section-84_1-form.component';
import { DiscardChangesComponent } from '../components/discard-changes/discard-changes.component';
import { CalculationStatusEnum } from '../../../../../../../common/src/enums/calculations/calculation-status.enum';

@Injectable()
export class CalculationFormEditingGuard implements CanDeactivate<Section84_1FormComponent> {
  canDeactivate(component: Section84_1FormComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (component.form.pristine === true ||
      component.calculationStatusEnum === CalculationStatusEnum.Completed ||
      component.calculationStatusEnum === CalculationStatusEnum.Error ||
      component.calculationStatusEnum === CalculationStatusEnum.InProgress) {
      return true;
    }

    return new Observable(subscriber => {
      const modal = component.modalService.open(DiscardChangesComponent);
      modal.closed.subscribe(result => {
        subscriber.next(result);
        subscriber.complete();
      });
    });
  }

}
